import React, { createContext, useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { swalToast } from 'helpers/customSwal';

export const LANG = {
  ZH_TW: 'zh-TW',
  EN: 'en',
};

export const DEFAULT_LANG = LANG.ZH_TW;

const LangContext = createContext(null);

export const useLangContext = () => useContext(LangContext);

export const LangProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(DEFAULT_LANG);
  const [changed, setChanged] = useState(false);
  const langPreference = localStorage.getItem('lang');

  const languageList = [
    {
      id: LANG.EN,
      title: 'English',
      hint: 'Language set.',
    },
    {
      id: LANG.ZH_TW,
      title: '繁體中文',
      hint: '語言已設定。',
    },
  ];

  useEffect(() => {
    if (langPreference) {
      setLang(langPreference);
    }
  }, []);

  useEffect(() => {
    const matchLang = languageList.find((v) => v.id === lang);
    if (matchLang) {
      i18n.changeLanguage(matchLang.id);
      localStorage.setItem('lang', lang);
      if (changed) {
        swalToast.fire({
          icon: 'info',
          title: matchLang.hint,
        });
        setChanged(false);
      }
    }
  }, [lang, i18n]);

  const contextData = { lang, setLang, setChanged };

  return (
    <LangContext.Provider value={contextData}>{children}</LangContext.Provider>
  );
};
